const fromPairs = (arr) => arr.reduce((acc, item) => {
    acc[item[0]] = item[1];
    return acc;
}, {});
const getDifference = (arr1, arr2) => {
    const nextArr1 = Object.entries(arr1);
    const nextArr2 = Object.entries(arr2);
    const disabled = nextArr1.filter(([item]) => nextArr2.findIndex(([nextItem]) => nextItem === item) === -1);
    const enabled = nextArr2.filter(([item]) => nextArr1.findIndex(([nextItem]) => nextItem === item) === -1);
    return { disabled: fromPairs(disabled), enabled: fromPairs(enabled) };
};
export default getDifference;
//# sourceMappingURL=getDifference.js.map